export default __webpack_public_path__ + "static/media/val_conv_2.e816e9f4.png";